import { Injectable } from '@angular/core';
import { ShippingAddressInfoConfig } from '../interface/shipping-address-info-config.interface';

@Injectable()
export class ShippingAddressInfoConfigService {
    constructor(
    ) { }

    /**
        * @description this method will get the config settings for shipping address info page
        * @date 2019-09-16
        * @memberof ShippingAddressInfoConfigService
        */
    public getSettings(countryCode: string): ShippingAddressInfoConfig {
        let shippingAddressInfoConfig: ShippingAddressInfoConfig;
        switch (countryCode.toUpperCase()) {
            case 'USA':
                shippingAddressInfoConfig = this.loadUSASettings();
                break;
            case 'CAN':
                shippingAddressInfoConfig = this.loadCANSettings();
                break;
            case 'GBR':
                shippingAddressInfoConfig = this.loadGBRSettings();
                break;
            case 'IRL':
                shippingAddressInfoConfig = this.loadIRLSettings();
                 break;
            case 'ILN':
                shippingAddressInfoConfig = this.loadILNSettings();
                break;
            case 'SWE':
                shippingAddressInfoConfig = this.loadSWESettings();
                break;
            case 'DNK':
                shippingAddressInfoConfig = this.loadDNKSettings();
                break;
            case 'NOR':
                shippingAddressInfoConfig = this.loadNORSettings();
                 break;
            case 'FIN':
                shippingAddressInfoConfig = this.loadFINSettings();
                break;
            case 'BEL':
                shippingAddressInfoConfig = this.loadBELSettings();
                break;
            case 'LUX':
                shippingAddressInfoConfig = this.loadLUXSettings();
                break;
            case 'NLD':
                shippingAddressInfoConfig = this.loadNLDSettings();
                break;        
            case 'POL':
                shippingAddressInfoConfig = this.loadPOLSettings();
                break;
            case 'DEU':
                shippingAddressInfoConfig = this.loadDEUSettings();
                break;
            case 'AUT':
                shippingAddressInfoConfig = this.loadAUTSettings();
                break;  
            case 'MKD':
                shippingAddressInfoConfig = this.loadMKDSettings();
                break;  
            case 'BGR':
                shippingAddressInfoConfig = this.loadBGRSettings();
                break;        
            case 'CHE':
                shippingAddressInfoConfig = this.loadCHESettings();
                break;
            case 'ISL':
                shippingAddressInfoConfig = this.loadISLSettings();
                break;        
            default:
                shippingAddressInfoConfig = this.loadUSASettings();
                break;
        }
        return shippingAddressInfoConfig;
    }

    /**
     * @description this method will return usa settings
     * @date 2019-09-19
     * @private
     * @returns {ShippingAddressInfoConfig}
     * @memberof ShippingAddressInfoConfigService
     */
    private loadUSASettings(): ShippingAddressInfoConfig {
        const shippingAddressInfoConfig: ShippingAddressInfoConfig = {
            countryCode: 'USA',
            isNavigateToDeliverypage: true,
            displayIDontHaveSponsorGuestSection: false,
            displayStateCode: true,
            isWaiveShippingCost: false,
            isBfpoOptionEnabled:true,
            pudoLocationsEnabled: false,
            disableCountryDropdowninPudoAddress: false,
            enablePudoShippingSchemaUrl: false,
            sendSourceToShippingOptions: false
        };
        return shippingAddressInfoConfig;
    }

    /**
     * @description this method will return CAN settings
     * @date 2019-09-19
     * @private
     * @returns {ShippingAddressInfoConfig}
     * @memberof ShippingAddressInfoConfigService
     */
    private loadCANSettings(): ShippingAddressInfoConfig {
        const shippingAddressInfoConfig: ShippingAddressInfoConfig = {
            countryCode: 'CAN',
            isNavigateToDeliverypage: true,
            displayIDontHaveSponsorGuestSection: false,
            displayStateCode: true,
            isWaiveShippingCost: false,
            isBfpoOptionEnabled:true,
            pudoLocationsEnabled: false,
            disableCountryDropdowninPudoAddress: false,
            enablePudoShippingSchemaUrl: false,
            sendSourceToShippingOptions: false
        };
        return shippingAddressInfoConfig;
    }

    /**
     * @description this method will return GBR settings
     * @date 2019-09-19
     * @private
     * @returns {ShippingAddressInfoConfig}
     * @memberof ShippingAddressInfoConfigService
     */
    private loadGBRSettings(): ShippingAddressInfoConfig {
        const shippingAddressInfoConfig: ShippingAddressInfoConfig = {
            countryCode: 'GBR',
            isNavigateToDeliverypage: false,
            displayIDontHaveSponsorGuestSection: true,
            displayStateCode: false,
            isWaiveShippingCost: true,
            isBfpoOptionEnabled:true,
            pudoLocationsEnabled: false,
            disableCountryDropdowninPudoAddress: false,
            enablePudoShippingSchemaUrl: false,
            sendSourceToShippingOptions: false,
            dropShipLocationsEnabled : false
        };
        return shippingAddressInfoConfig;
    }

     /**
     * @description this method will return GBR settings
     * @date 2019-09-19
     * @private
     * @returns {ShippingAddressInfoConfig}
     * @memberof ShippingAddressInfoConfigService
     */
    private loadIRLSettings(): ShippingAddressInfoConfig {
        const shippingAddressInfoConfig: ShippingAddressInfoConfig = {
            countryCode: 'IRL',
            isNavigateToDeliverypage: false,
            displayIDontHaveSponsorGuestSection: true,
            displayStateCode: true,
            isWaiveShippingCost: false,
            isBfpoOptionEnabled:false,
            pudoLocationsEnabled: false,
            disableCountryDropdowninPudoAddress: false,
            enablePudoShippingSchemaUrl: false,
            sendSourceToShippingOptions: false
        };
        return shippingAddressInfoConfig;
    }

     /**
     * @description this method will return GBR settings
     * @date 2019-09-19
     * @private
     * @returns {ShippingAddressInfoConfig}
     * @memberof ShippingAddressInfoConfigService
     */
    private loadILNSettings(): ShippingAddressInfoConfig {
        const shippingAddressInfoConfig: ShippingAddressInfoConfig = {
            countryCode: 'ILN',
            isNavigateToDeliverypage: false,
            displayIDontHaveSponsorGuestSection: true,
            displayStateCode: false,
            isWaiveShippingCost: true,
            isBfpoOptionEnabled:true,
            pudoLocationsEnabled: false,
            disableCountryDropdowninPudoAddress: false,
            enablePudoShippingSchemaUrl: false,
            sendSourceToShippingOptions: false
        };
        return shippingAddressInfoConfig;
    }

    /**
     * @description this method will return swe settings
     * @date 2021-07-06
     * @private
     * @returns {ShippingAddressInfoConfig}
     * @memberof ShippingAddressInfoConfigService
     */
     private loadSWESettings(): ShippingAddressInfoConfig {
        const shippingAddressInfoConfig: ShippingAddressInfoConfig = {
            countryCode: 'SWE',
            isNavigateToDeliverypage: true,
            displayIDontHaveSponsorGuestSection: false,
            displayStateCode:false,
            isWaiveShippingCost: false,
            isBfpoOptionEnabled:true,
            pudoLocationsEnabled: true,
            disableCountryDropdowninPudoAddress: true,
            enablePudoShippingSchemaUrl: false,
            sendSourceToShippingOptions: false
        };
        return shippingAddressInfoConfig;
    }

    /**
     * @description this method will return DNK settings
     * @date 2019-09-19
     * @private
     * @returns {ShippingAddressInfoConfig}
     * @memberof ShippingAddressInfoConfigService
     */
     private loadDNKSettings(): ShippingAddressInfoConfig {
        const shippingAddressInfoConfig: ShippingAddressInfoConfig = {
            countryCode: 'DNK',
            isNavigateToDeliverypage: true,
            displayIDontHaveSponsorGuestSection: false,
            displayStateCode: false,
            isWaiveShippingCost: false,
            isBfpoOptionEnabled:true,
            pudoLocationsEnabled: true,
            disableCountryDropdowninPudoAddress: true,
            enablePudoShippingSchemaUrl: false,
            sendSourceToShippingOptions: false
        };
        return shippingAddressInfoConfig;
    }

    /**
     * @description this method will return NOR settings
     * @date 2021-07-06
     * @private
     * @returns {ShippingAddressInfoConfig}
     * @memberof ShippingAddressInfoConfigService
     */
     private loadNORSettings(): ShippingAddressInfoConfig {
        const shippingAddressInfoConfig: ShippingAddressInfoConfig = {
            countryCode: 'NOR',
            isNavigateToDeliverypage: true,
            displayIDontHaveSponsorGuestSection: false,
            displayStateCode: false,
            isWaiveShippingCost: false,
            isBfpoOptionEnabled:true,
            pudoLocationsEnabled: true,
            disableCountryDropdowninPudoAddress: true,
            enablePudoShippingSchemaUrl: false,
            sendSourceToShippingOptions: false
        };
        return shippingAddressInfoConfig;
    }

    /**
     * @description this method will return FIN settings
     * @date 2021-07-06
     * @private
     * @returns {ShippingAddressInfoConfig}
     * @memberof ShippingAddressInfoConfigService
     */
     private loadFINSettings(): ShippingAddressInfoConfig {
        const shippingAddressInfoConfig: ShippingAddressInfoConfig = {
            countryCode: 'FIN',
            isNavigateToDeliverypage: true,
            displayIDontHaveSponsorGuestSection: false,
            displayStateCode: false,
            isWaiveShippingCost: false,
            isBfpoOptionEnabled:true,
            pudoLocationsEnabled: true,
            disableCountryDropdowninPudoAddress: true,
            enablePudoShippingSchemaUrl: false,
            sendSourceToShippingOptions: false
        };
        return shippingAddressInfoConfig;
    }


      /**
     * @description this method will return FIN settings
     * @date 2021-07-06
     * @private
     * @returns {ShippingAddressInfoConfig}
     * @memberof ShippingAddressInfoConfigService
     */
       private loadBELSettings(): ShippingAddressInfoConfig {
        const shippingAddressInfoConfig: ShippingAddressInfoConfig = {
            countryCode: 'BEL',
            isNavigateToDeliverypage: true,
            displayIDontHaveSponsorGuestSection: false,
            displayStateCode: true,
            isWaiveShippingCost: false,
            isBfpoOptionEnabled:true,
            pudoLocationsEnabled: true,
            disableCountryDropdowninPudoAddress: false,
            enablePudoShippingSchemaUrl: true,
            sendSourceToShippingOptions: false,
            dropShipLocationsEnabled:false,
        };
        return shippingAddressInfoConfig;
    }
      /**
     * @description this method will return FIN settings
     * @date 2021-07-06
     * @private
     * @returns {ShippingAddressInfoConfig}
     * @memberof ShippingAddressInfoConfigService
     */
       private loadLUXSettings(): ShippingAddressInfoConfig {
        const shippingAddressInfoConfig: ShippingAddressInfoConfig = {
            countryCode: 'LUX',
            isNavigateToDeliverypage: true,
            displayIDontHaveSponsorGuestSection: false,
            displayStateCode: true,
            isWaiveShippingCost: false,
            isBfpoOptionEnabled:true,
            pudoLocationsEnabled: true,
            disableCountryDropdowninPudoAddress: false,
            enablePudoShippingSchemaUrl: true,
            sendSourceToShippingOptions: false
        };
        return shippingAddressInfoConfig;
    }
      /**
     * @description this method will return FIN settings
     * @date 2021-07-06
     * @private
     * @returns {ShippingAddressInfoConfig}
     * @memberof ShippingAddressInfoConfigService
     */
       private loadNLDSettings(): ShippingAddressInfoConfig {
        const shippingAddressInfoConfig: ShippingAddressInfoConfig = {
            countryCode: 'NLD',
            isNavigateToDeliverypage: true,
            displayIDontHaveSponsorGuestSection: false,
            displayStateCode: true,
            isWaiveShippingCost: false,
            isBfpoOptionEnabled:true,
            pudoLocationsEnabled: true,
            disableCountryDropdowninPudoAddress: false,
            enablePudoShippingSchemaUrl: true,
            sendSourceToShippingOptions: false
        };
        return shippingAddressInfoConfig;
    }

    /**
     * @description this method will return POLAND store configuration
     * @author Akhil
     * @date 2021-09-29
     * @private
     * @returns {ShippingAddressInfoConfig}
     * @memberof ShippingAddressInfoConfigService
     */
    private loadPOLSettings(): ShippingAddressInfoConfig {
        const shippingAddressInfoConfig: ShippingAddressInfoConfig = {
            countryCode: 'POL',
            isNavigateToDeliverypage: true,
            displayIDontHaveSponsorGuestSection: false,
            displayStateCode: false,
            isWaiveShippingCost: false,
            isBfpoOptionEnabled: true,
            pudoLocationsEnabled: false,
            disableCountryDropdowninPudoAddress: false,
            enablePudoShippingSchemaUrl: false,
            sendSourceToShippingOptions: false
        };
        return shippingAddressInfoConfig;
    }
    private loadDEUSettings(): ShippingAddressInfoConfig {
        const shippingAddressInfoConfig: ShippingAddressInfoConfig = {
            countryCode: 'DEU',
            isNavigateToDeliverypage: true,
            displayIDontHaveSponsorGuestSection: false,
            displayStateCode:false,
            isWaiveShippingCost: false,
            isBfpoOptionEnabled:true,
            pudoLocationsEnabled: true,
            disableCountryDropdowninPudoAddress: true,
            enablePudoShippingSchemaUrl: false,
            sendSourceToShippingOptions: true
        };
        return shippingAddressInfoConfig;
    }
    private loadAUTSettings(): ShippingAddressInfoConfig {
        const shippingAddressInfoConfig: ShippingAddressInfoConfig = {
            countryCode: 'AUT',
            isNavigateToDeliverypage: true,
            displayIDontHaveSponsorGuestSection: false,
            displayStateCode:false,
            isWaiveShippingCost: false,
            isBfpoOptionEnabled:true,
            pudoLocationsEnabled: true,
            disableCountryDropdowninPudoAddress: true,
            enablePudoShippingSchemaUrl: false,
            sendSourceToShippingOptions: true
        };
        return shippingAddressInfoConfig;
    }
     /**
     * @description this method will return MKD store configuration
     * @date 2022-06-03
     * @private
     * @returns {ShippingAddressInfoConfig}
     * @memberof ShippingAddressInfoConfigService
     */
    private loadMKDSettings(): ShippingAddressInfoConfig {
        const shippingAddressInfoConfig: ShippingAddressInfoConfig = {
            countryCode: 'MKD',
            isNavigateToDeliverypage: true,
            displayIDontHaveSponsorGuestSection: false,
            displayStateCode: false,
            isWaiveShippingCost: false,
            isBfpoOptionEnabled: true,
            pudoLocationsEnabled: false,
            disableCountryDropdowninPudoAddress: false,
            enablePudoShippingSchemaUrl: false,
            sendSourceToShippingOptions: false,
            dropShipLocationsEnabled : true,
        };
        return shippingAddressInfoConfig;
    }
     /**
     * @description this method will return BGR store configuration
     * @date 2022-06-03
     * @private
     * @returns {ShippingAddressInfoConfig}
     * @memberof ShippingAddressInfoConfigService
     */
    private loadBGRSettings(): ShippingAddressInfoConfig {
        const shippingAddressInfoConfig: ShippingAddressInfoConfig = {
            countryCode: 'BGR',
            isNavigateToDeliverypage: true,
            displayIDontHaveSponsorGuestSection: false,
            displayStateCode: false,
            isWaiveShippingCost: false,
            isBfpoOptionEnabled: true,
            pudoLocationsEnabled: false,
            disableCountryDropdowninPudoAddress: false,
            enablePudoShippingSchemaUrl: false,
            sendSourceToShippingOptions: false,
            dropShipLocationsEnabled : true,
        };
        return shippingAddressInfoConfig;
    }
    private loadCHESettings(): ShippingAddressInfoConfig {
        const shippingAddressInfoConfig: ShippingAddressInfoConfig = {
            countryCode: 'CHE',
            isNavigateToDeliverypage: true,
            displayIDontHaveSponsorGuestSection: false,
            displayStateCode: false,
            isWaiveShippingCost: false,
            isBfpoOptionEnabled: true,
            pudoLocationsEnabled: false,
            disableCountryDropdowninPudoAddress: true,
            enablePudoShippingSchemaUrl: false,
            sendSourceToShippingOptions: true
        };
        return shippingAddressInfoConfig;
    }
    private loadISLSettings(): ShippingAddressInfoConfig {
        const shippingAddressInfoConfig: ShippingAddressInfoConfig = {
            countryCode: 'ISL',
            isNavigateToDeliverypage: false,
            displayIDontHaveSponsorGuestSection: true,
            displayStateCode: true,
            isWaiveShippingCost: false,
            isBfpoOptionEnabled: false,
            pudoLocationsEnabled: false,
            disableCountryDropdowninPudoAddress: false,
            enablePudoShippingSchemaUrl: false,
            sendSourceToShippingOptions: false
        };
        return shippingAddressInfoConfig;
    }
    
}



// WEBPACK FOOTER //
// ./src/app/customerservice/services/shipping-config.service.ts